<template>
  <div>
    <b-modal
      id="checkMultipleExcelCand-2"
      size="xl"
      centered
      hide-footer
      hide-header
      :visible="showModal"
      no-close-on-backdrop
      @hide="onHide"
    >
      <div class="cs-modal-header">
        <div>Added Candidates from Excel</div>
        <div class="pointer" @click="closeModal()">
          <img
            class="rotate-on-hover"
            src="../../../assets/img/accessconnew/blueCross.svg"
            alt=""
          />
        </div>
      </div>
      <div>
        <div class="border-bottom d-flex">
          <div
            style="width: 180px"
            :class="selectedTab == 'pass' ? 'exc-bluetab' : 'exc-blacktab'"
            class="pointer"
            @click="selectType('pass')"
          >
            Passed Candidates
            <div class="exc-cand-number ml-2">
              {{ filteredPassedCandidates.length }}
            </div>
            <div class="exc-sel-tab" v-if="selectedTab == 'pass'"></div>
          </div>
          <div
            style="width: 180px"
            :class="selectedTab == 'fail' ? 'exc-bluetab' : 'exc-blacktab'"
            class="pointer"
            @click="selectType('fail')"
          >
            Failed to upload
            <div class="exc-cand-number ml-2">
              {{ filteredFailedCandidates.length }}
            </div>

            <div class="exc-sel-tab" v-if="selectedTab == 'fail'"></div>
          </div>
        </div>
        <div
          class="
            d-flex
            justify-content-between
            align-items-center
            w-100
            pt-3
            pl-3
            pr-3
            pb-0
          "
        >
          <div v-if="showSearchBar" class="exc-seacrh position-relative w-50">
            <span>
              <img
                class="search-pos"
                src="../../../assets/img/search-bar-icon.svg"
                alt=""
              />
            </span>
            <b-form-input
              v-model="searchQuery"
              class="search-input"
              type="search"
              placeholder="Search Candidate"
            ></b-form-input>
          </div>

          <!-- <div class="tp-bluetxt mr-4" v-if="selectedTab == 'pass'">
            Selected Candidates:&nbsp; {{ selectedCandidateCount }}
          </div> -->
        </div>
        <div class="exc-main-table">
          <div v-if="(selectedTab == 'fail' && filteredFailedCandidates.length != 0) || (selectedTab == 'pass' && filteredPassedCandidates.length != 0)" class="exc-table-head">
            <!-- <div
              v-if="selectedTab == 'pass'"
              class="text-center"
              style="width: 5%"
            >
              <b-form-checkbox
                id="select-all"
                v-model="allSelected"
                @change="selectAll()"
              ></b-form-checkbox>
            </div> -->
            <div style="width: 15%; padding-left: 27px">
              <span class="mr-2">Source</span>

              <template v-if="sortValue == 'Profile Source'">
                <img
                  v-if="isSort"
                  class="pointer"
                  @click="setSort('Profile Source')"
                  src="../../../assets/img/accessconnew/ascSort.svg"
                  alt=""
                />
                <img
                  v-if="!isSort"
                  class="pointer"
                  @click="setSort('Profile Source')"
                  src="../../../assets/img/accessconnew/descSort.svg"
                  alt=""
                />
              </template>
              <img
                v-else
                class="pointer"
                src="../../../assets/img/accessconnew/nosort.svg"
                @click="setSort('Profile Source')"
                alt=""
              />
            </div>
            <div :style="selectedTab == 'pass' ? 'width: 15%' : 'width: 20%'">
              <span class="mr-2">Candidate Name</span>
              <template v-if="sortValue == 'Candidate Name'">
                <img
                  v-if="isSort"
                  class="pointer"
                  @click="setSort('Candidate Name')"
                  src="../../../assets/img/accessconnew/ascSort.svg"
                  alt=""
                />
                <img
                  v-if="!isSort"
                  class="pointer"
                  @click="setSort('Candidate Name')"
                  src="../../../assets/img/accessconnew/descSort.svg"
                  alt=""
                />
              </template>
              <img
                v-else
                class="pointer"
                src="../../../assets/img/accessconnew/nosort.svg"
                @click="setSort('Candidate Name')"
                alt=""
              />
            </div>
            <div :style="selectedTab == 'pass' ? 'width: 15%' : 'width: 20%'">
              <span class="mr-2">Email ID</span>
              <template v-if="sortValue == 'Email'">
                <img
                  v-if="isSort"
                  class="pointer"
                  @click="setSort('Email')"
                  src="../../../assets/img/accessconnew/ascSort.svg"
                  alt=""
                />
                <img
                  v-if="!isSort"
                  class="pointer"
                  @click="setSort('Email')"
                  src="../../../assets/img/accessconnew/descSort.svg"
                  alt=""
                />
              </template>
              <img
                v-else
                class="pointer"
                src="../../../assets/img/accessconnew/nosort.svg"
                @click="setSort('Email')"
                alt=""
              />
            </div>
            <div :style="selectedTab == 'pass' ? 'width: 9%' : 'width: 12%'">
              <span>Phone Number</span>
            </div>
            <div
              style="width: 24%"
              :class="selectedTab == 'pass' ? 'pl-5' : ''"
            >
              <span>Skills</span>
            </div>
            <div v-if="selectedTab == 'pass'" style="width: 6%"></div>
            <div
              v-if="selectedTab == 'pass'"
              class="text-center"
              style="width: 16%"
            >
              <span class="mr-2">Upload Resume</span>
            </div>
          </div>
          <div class="exc-table-body" id="top1">
            <template v-if="filteredPassedCandidates.length === 0 || filteredFailedCandidates.length === 0">
              <div
                v-if="
                  (selectedTab == 'pass' &&
                    filteredPassedCandidates.length === 0 &&
                    searchQuery !== '') ||
                  (selectedTab == 'fail' &&
                    filteredFailedCandidates.length === 0 &&
                    searchQuery !== '')
                "
                class="d-flex
                  justify-content-center
                  align-items-center
                  h-100
                  flex-column"
              >
               <img
                    src="../../../assets/img/accessconnew/emptyprivilageBig.svg"
                    alt=""
                  />
                No matching results for&nbsp;
                <strong> "{{ searchQuery }}" </strong>
              </div>

              <div
                v-else-if="
                  (selectedTab == 'pass' &&
                    passedCandidates.length === 0 &&
                    searchQuery === '') ||
                  (selectedTab == 'fail' &&
                    failedCandidates.length === 0 &&
                    searchQuery === '')
                "
                class="
                  d-flex
                  justify-content-center
                  align-items-center
                  h-100
                  flex-column
                "
              >
                <div>
                  <img
                    src="../../../assets/img/vendorcandidateanddashboard/no-data-export-excel.svg"
                    alt=""
                  />
                </div>
                <div class="search-result-empty-text mt-4">No Data Found.</div>
              </div>
            </template>
            <template v-if="selectedTab == 'pass'">
              <div
                v-for="(i, index) in filteredPassedCandidates"
                :key="index"
                class="exc-table-row"
              >
                <div class="relativeclass pl-4" style="width: 15%">
                  <div class="exc-gridfailed mr-1"></div>
                  <img :src="getSourceSvg(i['Profile Source'])" alt="" />
                </div>
                <div class="align-self-end pr-2" style="width: 15%">
                    <span v-b-tooltip.hover.top="i['Candidate Name']" class="d-inline-block text-truncate"
                    style="min-width: auto; max-width: 100%">
                      {{ i["Candidate Name"] }}
                    </span>
                </div>
                <div
                  class="align-self-end pr-2"
                  style="width: 15%"
                >
                  <span
                    v-b-tooltip.hover.top="i['Email']"
                    class="d-inline-block text-truncate"
                    style="min-width: auto; max-width: 100%"
                  >
                    {{ i["Email"] }}
                  </span>
                </div>
                <div style="width: 9%">{{ i["Phone Number"] }}</div>
                <div class="pl-5 align-self-end" style="width: 24%">
                  <span class="d-inline-block text-truncate" style="min-width: auto; max-width: 100%" v-b-tooltip.hover.top="i['Skill']">
                    {{ i["Skill"] | fnName }}
                  </span>
                </div>
                <div style="width: 6%" class="pl-3">
                  <img
                    @click="removeCandidate(index)"
                    v-b-tooltip.hover.top="'Remove Candidate'"
                    src="../../../assets/talentpool/removecand.svg"
                    alt=""
                    class="pointer"
                  />
                </div>
                <div class="d-flex justify-content-center" style="width: 16%">
                  <!-- RED BUTTON -->

                  <div
                    class="exc-redbtn pointer"
                    @click="clearResume(index)"
                    v-if="i.resumeFailed === true"
                  >
                    <div>
                      <img
                        class="mr-2"
                        src="../../../assets/talentpool/redResume.svg"
                        alt=""
                      />
                    </div>
                    Upload Resume
                    <div>
                      <img
                        class="ml-2"
                        src="../../../assets/talentpool/redcross.svg"
                        alt=""
                      />
                    </div>
                  </div>

                  <!-- BLUE BUTTON -->

                  <div
                    class="exc-bluebtn position-relative ucdSelDocFile"
                    :class="i.resumeLoading ? 'uploading-opacity' : 'pointer'"
                    v-else-if="
                      i.resumeName == null || (i.resumePath && i.resumeLoading)
                    "
                  >
                    <b-form-file
                      @input="handleClick(index, $event)"
                      v-model="i.resumeFile"
                      ref="excel-upload-input"
                      class="mb-2"
                      accept=".pdf,.doc,.docx"
                      :disabled="i.resumeLoading"
                    ></b-form-file>
                    <div>
                      <img
                        class="mr-2"
                        src="../../../assets/talentpool/blueResume.svg"
                        alt=""
                      />
                    </div>
                    Upload Resume
                    <div class="blue-loader-pos" v-if="i.resumeLoading">
                      <BlueLoader />
                    </div>
                  </div>

                  <!-- GREEN BUTTON -->

                  <div class="exc-greenbtn" v-else-if="i.resumeName != null">
                    <div>
                      <img
                        class="mr-2"
                        src="../../../assets/talentpool/greenResume.svg"
                        alt=""
                      />
                    </div>
                    <div class="text-truncate w-60">
                      {{ i.resumeName }}
                    </div>
                    <div class="pointer" @click="deleteResume(index)">
                      <img
                        class="ml-2"
                        src="../../../assets/talentpool/greencross.svg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div
                v-for="(i, index) in filteredFailedCandidates"
                :key="index"
                class="exc-table-row"
              >
                <div class="relativeclass pl-4" style="width: 15%">
                  <div class="exc-gridfailed mr-1"></div>
                  <img :src="getSourceSvg(i['Profile Source'])" alt="" />
                </div>
                <div style="width: 20%" class="align-self-end pr-2">
                    <span v-b-tooltip.hover.top="i['Candidate Name']" class="d-inline-block text-truncate"
                    style="min-width: auto; max-width: 100%">
                      {{ i["Candidate Name"] }}
                    </span>
                </div>
                <div
                  class="align-self-end pr-2"
                  style="width: 20%"
                >
                  <span v-b-tooltip.hover.top="i['Email']" class="d-inline-block text-truncate"
                    style="min-width: auto; max-width: 100%"
                  >
                    {{ i["Email"] }}
                  </span>
                </div>
                <div style="width: 12%">{{ i["Phone Number"] }}</div>
                <div class="pl-5 align-self-end" style="width: 24%">
                  <span class="d-inline-block text-truncate" style="min-width: auto; max-width: 100%" v-b-tooltip.hover.top="i['Skill']">
                    {{ i["Skill"] | fnName }}
                  </span>
                </div>
                <div style="width: 9%">
                  <div>
                    <img
                      v-b-tooltip.hover.top="i['Reason'].join(',')"
                      src="../../../assets/talentpool/redalerti.svg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div
        class="
          d-flex
          align-items-center
          justify-content-end
          w-100
          border-top
          bluebtn
          pt-3
          pb-3
          pl-4
          pr-4
        "
      >
        <b-button class="acs-cancelBtn-modal mr-3" @click="closeModal()"
          >Cancel</b-button
        >
        <div class="position-relative">
          <b-button
            class="acs-addBtn-modal"
            :class="
              showLoader || resumeUploaded == 0 || anyResumeLoading()
                ? 'done-loader-class defaultCursor'
                : 'pointer'
            "
            @click="
              showLoader || resumeUploaded == 0 || anyResumeLoading()
                ? ''
                : doneBtn()
            "
            :disabled="resumeUploaded == 0 || anyResumeLoading()"
            >{{ showLoader ? "" : "Done" }}</b-button
          >
          <div v-if="showLoader" class="done-loader-pos">
            <Loader />
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="warningmodal"
      centered
      hide-footer
      hide-header
      v-model="isWarning"
      @hidden="isWarning = false"
    >
      <div class="d-flex">
        <div class="mr-3">
          <img src="../../../assets/talentpool/yellowWarning.svg" alt />
        </div>
        <div>
          <div class="d-flex justify-content-between">
            <div class="acs-modal-head">Warning</div>
            <div @click="isWarning = false">
              <img
                class="rotate-on-hover"
                src="../../../assets/img/accessconnew/blueCross.svg"
                alt
              />
            </div>
          </div>
          <div class="acs-modal-content pr-3 mt-1" v-if="resumeUploaded > 0">
            Please note that for certain candidates, resumes have already been
            uploaded. If you choose to close the modal, these candidates will
            not be added to the
            {{ $route.name == "Talentpool" ? "Talentpool" : "job" }}. This
            action cannot be undone.
          </div>
          <div class="acs-modal-content pr-3 mt-1" v-else>
            Please note that candidates resumes are not uploaded. If you choose
            to close the modal, those candidates will not be added to the
            {{ $route.name == "Talentpool" ? "Talentpool" : "job" }}. This
            action cannot be undone.
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-end mt-4 bluebtn">
        <b-button class="acs-cancelBtn-modal mr-3" @click="isWarning = false"
          >Cancel</b-button
        >
        <div class="position-relative">
          <b-button
            class="acs-addBtn-modal pointer"
            @click="(isWarning = false), $emit('close-modal')"
            >Continue</b-button
          >
        </div>
      </div>
    </b-modal>
    <b-modal
      id="continuemodal"
      centered
      hide-footer
      hide-header
      v-model="isContWarning"
      @hidden="closeWarning()"
    >
      <div class="d-flex">
        <div class="mr-3">
          <img src="../../../assets/talentpool/yellowWarning.svg" alt />
        </div>
        <div>
          <div class="d-flex justify-content-between">
            <div class="acs-modal-head">Warning</div>
            <div @click="closeWarning()">
              <img
                class="rotate-on-hover"
                src="../../../assets/img/accessconnew/blueCross.svg"
                alt
              />
            </div>
          </div>
          <div class="acs-modal-content pr-3 mt-1">
            Please note that for some candidates, resumes have not been
            uploaded. If you choose to continue, those candidates whose resumes
            have not been uploaded from the list will not be added to
            {{
              $route.name == "Talentpool"
                ? "the Talentpool"
                : "this particular job"
            }}
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-end mt-4 bluebtn">
        <b-button class="acs-cancelBtn-modal mr-3" @click="closeWarning()"
          >Cancel</b-button
        >
        <div class="position-relative">
          <b-button
            class="acs-addBtn-modal"
            :class="
              showContLoader ? 'continue-loader-class defaultCursor' : 'pointer'
            "
            @click="showContLoader ? '' : continueBtn()"
            >{{ showContLoader ? "" : "Continue" }}</b-button
          >
          <div v-if="showContLoader" class="continue-loader-pos">
            <Loader />
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { getSource } from "../../../utils/customFields";
import toast from "../../../components/mixin/toast";
import {
  uploadResumeExcel,
  uploadExcResumeNew,
  addCandidateExcel,
} from "../../../utils/apiFunctions";
import Loader from "../../../components/fixedcomponents/Loader.vue";
import BlueLoader from "../../../components/fixedcomponents/BlueLoader.vue";
export default {
  name: "MultiExcelCandidate",
  data() {
    return {
      sortValue: "",
      searchQuery: "",
      selectedTab: "pass",
      resumeUploaded: 0,
      isSort: false,
      showLoader: false,
      isWarning: false,
      showContLoader: false,
      isContWarning: false,
      candType: null,
      passedCandidates: [],
      failedCandidates: [],
    };
  },
  mixins: [toast],
  props: {
    multiExcelCands: Object,
    showModal: Boolean,
    passedExcCandidates: Array,
    failedExcCandidates: Array,
    particularJob: Object,
  },
  components: {
    Loader,
    BlueLoader,
  },
  filters: {
    fnName: function (value) {
      if (Array.isArray(value)) {
        if (value.length <= 3) {
          return value.join(", ");
        } else {
          return value.slice(0, 3).join(", ") + "...";
        }
      } else {
        return value;
      }
    },
  },
  created() {
    this.passedCandidates = this.passedExcCandidates;
    for (let i in this.passedCandidates) {
      if (!this.passedCandidates[i].resume) {
        this.passedCandidates[i].resumeName = null;
      } else {
        this.resumeUploaded++;
        this.passedCandidates[i].resumeName = this.getResumeName(
          this.passedCandidates[i].resumeLink
        );
      }
      this.passedCandidates[i].showUploadResume = false;
    }
    for (let i = 0; i < this.filteredPassedCandidates.length; i++) {
      if (this.filteredPassedCandidates[i].resumePath)
        this.uploadExistingResume(i);
    }
    this.failedCandidates = this.failedExcCandidates;
    this.selectType("pass");
  },
  computed: {
    showSearchBar(){
      if(this.selectedTab == 'pass') return  this.passedCandidates.length != 0;
      else return  this.failedCandidates.length != 0;
    },
    filteredPassedCandidates() {
      // Apply both sort and filter
      let filteredItems = this.passedCandidates.filter((item) => {
        const term = this.searchQuery.toLowerCase();
        return (
          item["Candidate Name"].toLowerCase().includes(term) ||
          item["Email"].toString().includes(term)
        );
      });

      if (this.sortValue) {
        filteredItems.sort((a, b) => {
          let modifier = this.isSort ? 1 : -1;
          if (a[this.sortValue] < b[this.sortValue]) return -1 * modifier;
          if (a[this.sortValue] > b[this.sortValue]) return 1 * modifier;
          return 0;
        });
      }

      return filteredItems;
    },
    filteredFailedCandidates() {
      let filteredItems = this.failedCandidates.filter((item) => {
        const term = this.searchQuery.toLowerCase();
        return (
          item["Candidate Name"].toLowerCase().includes(term) ||
          item["Email"].toString().includes(term)
        );
      });

      if (this.sortValue) {
        filteredItems.sort((a, b) => {
          let modifier = this.isSort ? 1 : -1;
          if (a[this.sortValue] < b[this.sortValue]) return -1 * modifier;
          if (a[this.sortValue] > b[this.sortValue]) return 1 * modifier;
          return 0;
        });
      }

      return filteredItems;
    },
  },
  watch: {
    multiExcelCands(val) {
      if (val && Object.keys(val).length != 0) {
        if (this.resumeUploaded == this.passedCandidates.length) {
          this.showLoader = true;
          this.addCandidate(val.type);
        } else {
          this.candType = val.type;
          this.isContWarning = true;
        }
      }
    },
  },
  methods: {
    onHide(bvEvent) {
      if (bvEvent.trigger === 'esc') {
        console.log('ESC key pressed!')
        this.closeModal()
        // prevent modal from closing automatically if you want
        bvEvent.preventDefault()
      }
    },
    closeWarning() {
      this.isContWarning = false;
      if (this.$route.name == "Kanban") {
        this.candType = null;
        this.$emit("stop-spinner");
      }
    },
    anyResumeLoading() {
      return this.filteredPassedCandidates.some(
        (obj) => obj.resumeLoading === true
      );
    },
    getResumeName(resumeLink) {
      return resumeLink
        .substring(resumeLink.lastIndexOf("/") + 1)
        .split("?")[0];
    },
    async handleClick(index) {
      this.filteredPassedCandidates[index].resumeLoading = true;
      this.$forceUpdate();
      if (this.filteredPassedCandidates[index].resumeFile) {
        const size = this.filteredPassedCandidates[index].resumeFile.size;
        const fileSizeInMb = size / (1024 * 1024);
        const fileName = this.filteredPassedCandidates[index].resumeFile.name;
        const fileExtension = fileName.split(".").pop().toLowerCase(); //
        const allowedExtensions = ["pdf", "doc", "docx"];
        if (!allowedExtensions.includes(fileExtension)) {
          this.filteredPassedCandidates[index].resumeLoading = false;
          this.filteredPassedCandidates[index].resumeFailed = true;
          this.filteredPassedCandidates[index].resume = false;
          this.filteredPassedCandidates[index].resumeName = null;
          this.filteredPassedCandidates[index].resumeFile = null;
          this.$forceUpdate();
          this.errorModal("Please Upload pdf");
        } else if (fileSizeInMb > 10) {
          this.filteredPassedCandidates[index].resumeLoading = false;
          this.filteredPassedCandidates[index].resumeFailed = true;
          this.filteredPassedCandidates[index].resume = false;
          this.filteredPassedCandidates[index].resumeName = null;
          this.filteredPassedCandidates[index].resumeFile = null;
          this.$forceUpdate();
          this.errorModal("File size should not exceed 10MB");
          return;
        } else {
          let form = new FormData();
          form.append("email", this.filteredPassedCandidates[index].Email);
          form.append(
            "resume",
            this.filteredPassedCandidates[index].resumeFile
          );
          const response = await uploadResumeExcel(form);
          if (response.status == 200) {
            this.resumeUploaded++;
            this.filteredPassedCandidates[index].resumeName =
              this.filteredPassedCandidates[index].resumeFile.name;
            this.filteredPassedCandidates[index].resumeLoading = false;
            this.$forceUpdate();
          } else {
            this.filteredPassedCandidates[index].resumeLoading = false;
            this.$forceUpdate();
            this.errorModal("Something went wrong!");
          }
        }
      }
      // this.filteredPassedCandidates[index].resumeLoading = false;
    },
    async uploadExistingResume(index) {
      this.filteredPassedCandidates[index].resumeLoading = true;
      this.$forceUpdate();
      let form = new FormData();
      form.append("email", this.filteredPassedCandidates[index].Email);
      form.append(
        "resumeLink",
        this.filteredPassedCandidates[index].resumePath
      );
      const response = await uploadResumeExcel(form);
      if (response.status == 200) {
        this.filteredPassedCandidates[index].resumeLoading = false;
        this.$forceUpdate();
      }
    },
    selectType(type) {
      this.searchQuery = "";
      this.isSort = false;
      this.sortValue = "";
      this.selectedTab = type;
    },
    getSourceSvg(type) {
      return getSource(type);
    },
    removeCandidate(index) {
      if (
        this.passedCandidates[index].resume ||
        (this.passedCandidates[index].resumeFile !== null &&
          this.passedCandidates[index].resumeFile !== undefined)
      ) {
        this.resumeUploaded--;
      }
      this.successModal("Candidate removed successfully");
      this.passedCandidates.splice(index, 1);
    },
    async deleteResume(index) {
      this.$forceUpdate();
      let form = new FormData();
      form.append("email", this.passedCandidates[index].Email);
      form.append("deleteResume", "");
      const res = await uploadExcResumeNew(form);
      if (res.status == 200) {
        this.passedCandidates[index].resumeName = null;
        this.passedCandidates[index].resumeFile = null;
        this.passedCandidates[index].resume = false;
        this.resumeUploaded--;
        this.$forceUpdate();
      }
    },
    clearResume(index) {
      this.passedCandidates[index].resumeName = null;
      this.passedCandidates[index].resumeFile = null;
      this.passedCandidates[index].resumeFailed = false;
      this.$forceUpdate();
    },
    setSort(type) {
      if (this.sortValue != type) {
        this.isSort = true;
      } else {
        this.isSort = !this.isSort;
      }
      this.sortValue = type;
    },
    findObjectWithValue(array, key, value) {
      for (let i = 0; i < array.length; i++) {
        if (array[i][key] === value) {
          return array[i]; // Return the object if value is found
        }
      }
      return null; // Return null if value is not found
    },
    closeModal() {
      if(this.passedCandidates && this.passedCandidates.length != 0){
        this.isWarning = true;
      }
      else {
        this.$emit('close-modal');
      }
    },
    continueBtn() {
      this.showContLoader = true;
      this.addCandidate(this.candType);
    },
    doneBtn() {
      if (this.$route.name == "Kanban") {
        if (this.particularJob.positionIDs.length > 1) {
          let validCands = this.passedCandidates.filter(
            (obj) => obj.resumeFile || obj.resume
          );
          let newCands = validCands.map((obj) => {
            obj.email = obj["Email"];
            obj.name = obj["Candidate Name"];
            return obj;
          });
          this.$emit("show-add-cands", newCands);
        } else {
          this.addCandidate("automatic");
        }
      } else {
        if (this.resumeUploaded == this.passedCandidates.length) {
          this.showLoader = true;
          this.addCandidate();
        } else {
          this.isContWarning = true;
        }
      }
    },
    async addCandidate(type) {
      let payload = {
        emailIDs: [],
      };
      for (let candidate of this.passedCandidates) {
        if (candidate.resumeName !== null) {
          payload.emailIDs.push(candidate.Email);
        }
      }
      if (this.$route.name == "VendorKanban") {
        payload.jobID = this.particularJob.jobID;
        payload.customerID = this.particularJob.customerID;
        payload.vendorID = this.$route.params.vendorID;
      } else if (this.$route.name == "Kanban") {
        payload.jobID = this.particularJob.jobID;
        payload.customerID = this.particularJob.customerID;
      }
      if (type && type == "manual") {
        let positionValues = {};
        this.multiExcelCands.cands.map((obj) => {
          positionValues[obj.email] = obj.positionID;
        });
        payload.positions = positionValues;
      }
      if (type && type == "automatic") payload.automatic = true;
      const res = await addCandidateExcel(payload);
      if (res.status == 200) {
        this.successModal("Candidates added successfully");
        this.resumeUploaded = 0;
        this.isContWarning = false;
        this.showLoader = false;
        this.$emit("close-modal");
        this.$emit("update-talent-pool");
      } else {
        this.showLoader = false;
        this.$emit("close-jd-modals");
        this.errorModal("Something went wrong!");
      }
      this.candType = null;
    },
  },
};
</script>

<style>
.done-loader-class {
  opacity: 0.5;
  height: 29px;
  width: 88px;
}

.done-loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: -1px;
}

.continue-loader-class {
  opacity: 0.5;
  height: 29px;
  width: 107px;
}

.continue-loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: 4px;
}

.blue-loader-pos {
  position: absolute;
  top: -53px;
  left: 40px;
}

.uploading-opacity {
  opacity: 0.5;
}
</style>
